import {Box} from "@mui/material";
import {Outlet} from "react-router";
import Header from "./header/Header";
import Footer from "./Footer";
import pattern from '../assets/pattern.svg'

const Layout = () => {

    return (
        <Box
            sx={{
                minHeight: "100dvh",
                display: "flex",
                flexDirection: "column",
            }}
        >
            {/* Pattern layer */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundImage: `url(${pattern})`,
                    backgroundRepeat: 'repeat',
                    zIndex: 0,
                    overflow: "hidden",
                    pointerEvents: 'none'
                }}
            />

            <Header/>
            <Box sx={{flexGrow: 1, display: "flex", justifyContent: "center"}}>
                <Box sx={{maxWidth: 1000, width: "100%"}}>
                    <Outlet/>
                </Box>
            </Box>
            <Footer/>
        </Box>
    )
}

export default Layout;